require('../../../../../vendor/assets/javascripts/i18n/moment/en')
require('../../../../../vendor/assets/javascripts/i18n/moment/ja')
require('../../../../../vendor/assets/javascripts/i18n/moment/ko')
require('../../../../../vendor/assets/javascripts/i18n/moment/zh-tw')
require('../../../../../vendor/assets/javascripts/i18n/moment/tw')
require('../../../../../vendor/assets/javascripts/i18n/moment/zh-cn')
require('../../../../../vendor/assets/javascripts/i18n/moment/th')
require('../../../../../vendor/assets/javascripts/i18n/moment/id')
